import { render, staticRenderFns } from "./LppBalance.vue?vue&type=template&id=6b8aabd4&"
import script from "./LppBalance.vue?vue&type=script&lang=js&"
export * from "./LppBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports